// Если высота aside больше контента
function setContentHinHeight() {
  const aside = document.querySelector('.layout-aside-sticky')
  const content = document.querySelector('.layout-wrap-sections__content')

  if (!aside || !content) return

  if (!(aside && content)) return

  if (aside.clientHeight > content.offsetHeight) {
    content.style.minHeight = `${aside.offsetHeight}px`
  }
}

if (document.documentElement.clientWidth >= 1366) {
  setContentHinHeight()
}

window.addEventListener('resize', () => {
  if (document.documentElement.clientWidth >= 1366) {
    setContentHinHeight()
  }
})
